<template>
  <v-layout wrap align-center justify-start>
    <span class="title my-auto" style="color: black">Capítulos</span>
    <v-flex xs12 class="mt-1">
      <lister
        :items="shownChapters"
        :cardBreakpoints="'xs12 sm6 md6 lg6 xl4'"
        :autosort="false"
        :emptyListMessage="'Nenhum capítulo cadastrado...'"
        searchText
        hideSearchbar
        emptyListIcon
      >
      <template v-slot:default="slotProps">
        <chapter-item :chapter="slotProps.item" :key="slotProps.item.id" />
      </template>
      </lister>
    </v-flex>
  </v-layout>
</template>

<script>
import Lister from '@/components/Lister.vue';
import { db, rdb } from '@/firebase/config';
import ChapterItem from './ChapterItem.vue';

export default {
  components: {
    Lister,
    ChapterItem,
  },
  data: () => ({
    chapters: [],
    reorderedChapters: [],
    chapterOrder: null,
  }),
  firestore: {
    chapters: db.collection('chapters'),
  },
  firebase: {
    chapterOrder: rdb.ref('chapterOrder'),
  },
  computed: {
    shownChapters() {
      if (this.chapterOrder == null) {
        return [];
      }
      const shown = this.chapters.slice();
      shown.sort(this.sortChapters);
      return shown;
    },
    sortChapters() {
      return (a, b) => {
        const indexA = this.chapterOrder.indexOf(a.id);
        const indexB = this.chapterOrder.indexOf(b.id);
        return indexA - indexB;
      };
    },
  },
};
</script>
